import script from "./SurveyCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyCustomer.vue?vue&type=script&setup=true&lang=js"

import "./SurveyCustomer.vue?vue&type=style&index=0&id=45b544e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b544e7"]])

export default __exports__